import {
  Component, ElementRef, Input, OnInit, ViewChild
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { FormsFieldsState, ModifierTypes } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @ViewChild('input') inputField!: ElementRef;

  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() suffix?: string;

  @Input() prefix?: string;

  @Input() type?: ('text' | 'number' | 'password') = 'text';

  @Input() step?: number;

  @Input() placeholder = '';

  @Input() layoutMod: ModifierTypes[] = [];

  @Input() textAlign?: ('' | 'left' | 'right' | 'center') = '';

  @Input() autoFocus = false;

  @Input() highlight = false;

  @Input() autoWidth = false;

  @Input() blurOnEnter?: boolean;

  @Input() state?: FormsFieldsState;

  @Input() charCounter?: boolean;

  @Input() maxChars = 20;

  currentLength = 0;

  layoutModifier = '';

  control!: AbstractControl | null;

  emitOnEnter = false;

  get valueOfStep(): number | null {
    let res = null;
    if (this.type === 'number' && this.control?.value) {
      const isInt = Number.isInteger(Number(this.control.value));
      // eslint-disable-next-line no-nested-ternary
      res = (this.step ? this.step : (!isInt ? 0.01 : null));
    }

    return res;
  }

  constructor(
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.emitOnEnter = (this.blurOnEnter ? this.blurOnEnter : (this.type !== 'password'));
    this.control = this.mainForm.controls[this.controlName];
    this.layoutModifier = this.stylingService.concatLayoutModifiers('inputField', this.layoutMod);

    if (this.charCounter) {
      this.currentLength = Math.min(this.control.value.length, this.maxChars) || 0;
    }
  }

  onEnter(event: Event) : void {
    if (this.emitOnEnter) {
      (event.target as HTMLInputElement).blur();
    }
  }

  onAutoWidthClick() : void {
    if (this.autoWidth) {
      setTimeout(() => {
        this.inputField.nativeElement.focus();
      });
    }
  }

  updateCount(event: Event) {
    if (!this.charCounter) {
      return;
    }
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    if (inputValue.length > this.maxChars) {
      const newValue = inputValue.slice(0, this.maxChars);
      input.value = newValue;
      this.mainForm.controls[this.controlName].setValue(newValue, { emitEvent: false })
    }

    this.currentLength = input.value.length;

  }

}
